export default function /* @ngInject */ stripeData(stripeExpirationMonths, stripeExpirationYears) {
    return {
        months: stripeExpirationMonths,
        years: stripeExpirationYears
    };
}



// WEBPACK FOOTER //
// ./stripe/services/stripe-data.js